// @flow

/* eslint-disable import/prefer-default-export */
export function interpolateWith(str: string, replacements: Object): string {
  if (!str) return '';

  return Object.keys(replacements)
    .reduce((acc, key) => {
      const pattern = new RegExp(`(^|[^\\\\]):${key}`, 'g');
      const content = replacements[key] === 0 ? 0 : replacements[key] || '';
      const replaceString = content.toString().replace(/^\$1/, '$$$1');
      return acc.replace(pattern, `$1${replaceString}`);
    }, str)
    .replace(/\\:/, ':');
}
